import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext, useEffect, useState } from "react"
import { useMutation, useQuery } from "react-query"
import {
  createDiscount,
  listDiscounts,
  setDiscountCourses,
} from "~/actions/discounts"
import AdminActionBar from "~/components/Common/AdminActionBar"
import DiscountCardList from "~/components/Discounts/DiscountCardList"
import AppContext from "~/contexts/App"
import { DiscountsContainer } from "~/contexts/Discounts"
import Page from "~/pages/Page"
import Router from "~/router"

import usePermissionsRedirect from "~/hooks/usePermissionsRedirect"
import useStyles from "./styles"

const Discounts = ({ routes = [], ...rest }) => {
  const classes = useStyles()
  const [searchValue, setSearchValue] = useState("")

  const [sort, setSort] = useState({
    name: "",
    type: "",
    direction: "",
    icon: "",
  })

  const filterOptions = [
    { id: 1, name: "Name" },
    { id: 2, name: "Type" },
    { id: 3, name: "Start Date" },
    { id: 4, name: "Used" },
  ]

  const { setPageTitle, setPageSubTitle, openDialog, authUser } =
    useContext(AppContext)
  const createDiscountMutation = useMutation((data) => createDiscount(data))
  const setDiscountCoursesMutatation = useMutation((data) =>
    setDiscountCourses(data.courses, data.id),
  )
  const { data: discounts, isLoading: discountsLoading } = useQuery(
    "discounts",
    () => listDiscounts(),
  )
  usePermissionsRedirect("/learning-paths", "discounts")

  useEffect(() => {
    setPageTitle("Discount Codes")
    setPageSubTitle(discounts?.length)
  }, [])

  const handleOpen = () => {
    openDialog("createDiscount", {
      create: createDiscountMutation,
      setDiscountCourses: setDiscountCoursesMutatation,
    })
  }

  return (
    <Page>
      <DiscountsContainer>
        <AdminActionBar
          buttonName="New Code"
          buttonFunc={handleOpen}
          sortOptions={filterOptions}
          sortState={sort}
          setSortState={setSort}
          setFilterState={setSearchValue}
          placeholder="Search discount codes"
        />
        {discountsLoading ? (
          <LinearProgress color="primary" />
        ) : (
          <DiscountCardList
            searchValue={searchValue}
            discounts={discounts}
            handleOpen={handleOpen}
            sort={sort}
          />
        )}
        <Router routes={routes} {...rest} />
      </DiscountsContainer>
    </Page>
  )
}

Discounts.propTypes = {
  routes: PropTypes.array,
}

export default Discounts
